import { FloatingIndicator, Group, Tabs } from '@mantine/core';
import { usePermissions } from '@sportybot-web/auth/permissions/use-permissions';
import { useLocation, useNavigate } from '@tanstack/react-router';

import { NAV_LINKS, type TabPath } from '../constants';
import { FloatingTabs } from '../floating-tabs/floating-tabs';
import { UserMenu } from '../user-menu';
import classes from './desktop-nav.module.css';
import { getActiveTabPath } from './utils';

const { indicator, ...tabClasses } = classes;

export function DesktopNav() {
  const { can } = usePermissions();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const activeTab = getActiveTabPath(pathname);

  return (
    <>
      <FloatingTabs
        classNames={tabClasses}
        links={NAV_LINKS}
        onChange={(value) => navigate({ to: value as TabPath })}
        renderIndicator={(parent, target) => (
          <FloatingIndicator className={indicator} parent={parent} target={target} />
        )}
        renderTab={({ icon: Icon, label, permissions, to }, setControlRef) => {
          if (permissions && !can(permissions)) {
            return null;
          }

          return (
            <Tabs.Tab key={to} ref={setControlRef(to)} value={to}>
              <Icon size={16} />
              {label}
            </Tabs.Tab>
          );
        }}
        value={activeTab}
        variant="none"
        visibleFrom="sm"
      />

      <Group justify="end" visibleFrom="sm">
        <UserMenu />
      </Group>
    </>
  );
}
